<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <revenue-chart
            class="pb-4"
            :model-id='id'
            model-key="agent_id"
            url="agentrevenuestats"
            :entity-title="entityTitle"
        ></revenue-chart>    
        <companies-distribution
            :model-id='id'
            model-key="agent_id"
            url="companiesdistribution"
            title="Acquisizione Clienti"
            :entity-title="entityTitle"
        ></companies-distribution>
    </v-row>
</template>

<script>

    import RevenueChart from '@/components/common/RevenueChart'
    import CompaniesDistribution from '@/components/common/CompaniesDistribution'
    
    export default {
        name: 'agent-analytics',
        components: {
            RevenueChart,
            CompaniesDistribution
        },
        props: {
            id: Number,
            entityTitle: String,
        },

        created() {
           this.$store.commit('endProgress')
        },
    }
</script>